/* global console window document */

import Vue from "vue";
import $ from "jquery";

import facets from "facets";

import facetedListTemplate from "./templates/faceted-list.html";
import facetTemplate from "./templates/facet.html";

import { trans } from "common/translate";

// TODO: The following translations have to be added in localization files:
// * Browse by Site
// * Browse by Language
// * Browse by Content

$(() => {

  // A single facet component, optionally with children
  Vue.component("facet", {
    props: ["name", "count", "children", "url", "nested", "visible"],
    data() { return { expanded: false, hasFocus: false, trans }; },
    created() {
      // Listen to parent collapse events and collapse this item as well
      this.$parent.$on("collapseEvent", () => { this.expanded = false; });
    },

    computed: {
      internetExplorer() {
        return !!window.MSInputMethodContext && !!document.documentMode;
      }
    },

    methods: {
      clicked() {
        console.log("Clicked a facet");
        if (this.internetExplorer) {
          console.log("IE detected. Setting URL.");
          document.location.href = this.url;
        }
      }
    },
    template: facetTemplate
  });

  // A list of facets with state controls
  const facetedList = Vue.component("faceted-list", {
    props: ["terms", "title"],
    data() { return { expanded: false, trans }; },
    watch: {
      expanded(val) {
        if (!val) {
          // Tell children that this component has collapsed
          this.$emit("collapseEvent");
        }
      }
    },
    template: facetedListTemplate
  });

  // The lists themselves
  new Vue({
    el: "#faceted-list-site",
    render: (cElm) => cElm(facetedList, {
      props: {
        title: trans("Browse by Site"),
        terms: facets.site
      }
    })
  });
  new Vue({
    el: "#faceted-list-language",
    render: (cElm) => cElm(facetedList, {
      props: {
        title: trans("Browse by Language"),
        terms: facets.language
      }
    })
  });
  new Vue({
    el: "#faceted-list-content",
    render: (cElm) => cElm(facetedList, {
      props: {
        title: trans("Browse by Content"),
        terms: facets.content
      }
    })
  });

  // Top box / help box
  new Vue({
    el: "#faceted-list-top-box-site",
    data: { flipped: false }
  });
  new Vue({
    el: "#faceted-list-top-box-language",
    data: { flipped: false }
  });
  new Vue({
    el: "#faceted-list-top-box-content",
    data: { flipped: false }
  });
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/faceted-list.js